import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { BaseComponent } from '../../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Reportv2Tab, Reportv2TabList } from '../reportv2.const';
import { ReportService } from '../../../../../common/services/Report.service';
import { Observable } from 'rxjs/Rx';
import * as _ from 'lodash';
import * as Highcharts from 'highcharts';
import { SearchService } from 'app/common/services/Search.service';
import { UserService } from '../../../../../common/services/User.service';
import { SocketService } from '../../../../../common/services/Socket.service';
import { ExportCustomService } from 'app/common/services/ExportCustom.service';
import { GroupService } from 'app/common/services/Group.service';
import { TicketService } from 'app/common/services/Ticket.service';
import { CampaignService } from 'app/common/services/Campaign.service';
import { FieldService } from 'app/common/services/Field.service';
import { ReportGroupConst } from './group.const';
import { CommonSettingsService } from '../../../../../common/share-data/common.setting.service';
import { SharedUserService } from '../../../../../common/share-data/user.service';
import { CommonService } from '../../../../../common/services/Common.service';
declare var require: any;

const moment = require('moment');

declare var $: any;
@Component({
  selector: 'report-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.css', './ticket-search.module.css'],
  providers: [
    FieldService,
    ReportService,
    SearchService,
    ExportCustomService,
    GroupService,
    TicketService,
    CampaignService,
  ],
})
export class GroupComponent extends BaseComponent implements OnChanges, AfterViewInit {
  @Output() onChangeTab: EventEmitter<{ tab: any }> = new EventEmitter();
  @ViewChild('templateFilter') templateFilter: ElementRef;

  public dataSessionLeaveKeyLists: any = [
    { key: 'short', name: 'Short' },
    { key: 'long', name: 'Long' },
  ];
  public filterSearchKey = 'search_user';
  public filterHtml: any = {};
  public data_search: any = {};
  public is_updated = false;
  public data: any = [];
  public selectFilter: any = 'Bộ lọc mới';

  public totalItem: any = 0;
  public totalPage: any = 0;
  public currentPage = 1;
  public page_size = 10;
  public loadDetailTicketKey = '';
  public displayFilter = false;
  public filterModal: any = {};

  public page_size_ticket = 10;
  public currentPageTicket = 1;
  public totalItemTicket = 1;
  public totalPageTicket: any = 0;
  public active_fields: any = [];

  public listToExportTicket: any = {};
  public isItemDetailActive: any = {};
  public dataDetailTicket: any = null;
  public displayColumns: any[] = [];
  public dataReceptionTop: any = [];
  public dataSummaryWorkingTime: any = [];
  public dataSummaryWorkingTimeView: any = [];
  public exportFields: any[] = [];
  public isLoading: boolean = true;

  public dataReceptionDetail: any = null;
  public allUsers: any[] = [];
  public displayColumnsTicket: any[] = [];
  public modelFilter: any = {
    from_date: new Date(new Date().setDate(new Date().getDate() - 7)),
    to_date: new Date(),
    amount: 5,
    group_id_receive: 'all',
    group_id_agent_working: 'all',
  };
  public autoSubmitOnInit: boolean = false;
  public exportType = {
    ReceptionTop: 'ReceptionTop',
  };

  public groupUser: any[] = [];

  public readonly tabList = Reportv2TabList;
  public readonly Reportv2Tab = Reportv2Tab;
  private _filterChecked: any = null;

  public get filterChecked() {
    return this._filterChecked ? this._filterChecked._id : null;
  }

  public set filterChecked(value) {
    this._filterChecked = this.filterChecked === value._id ? null : value;
    this.choiceFilter(this._filterChecked);
  }

  public ticketFields: any = [];
  public customFields: any = [];

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private reportService: ReportService,
    private exportCustomService: ExportCustomService,
    private sharedCommonSettings: CommonSettingsService,
    private commonService: CommonService
  ) {
    super(changeDetector, toastr, modalService);
  }
  chartOptions: Highcharts.Options;

  // tslint:disable-next-line:use-life-cycle-interface
  async ngOnInit() {
    this.is_loading = true;
    await this.loadTicketFields();
    const customFields = ReportGroupConst.customFields(this.ticketFields);
    this.displayColumns = ReportGroupConst.displayColumns(this.ticketFields);
    // @ts-ignore
    const { report_user_group_table_columns } = (await this.sharedCommonSettings.getUserConfig()) || {};
    if (report_user_group_table_columns) {
      const saveDisplayColumns = JSON.parse(report_user_group_table_columns);
      this.customFields = customFields.map(d => {
        try {
          const sD = saveDisplayColumns.find(sd => d.field === sd.field);
          if (sD) {
            d.display = sD.display;
          }
          return d;
        } catch (e) {
          return d;
        }
      });
      this.displayColumns = this.displayColumns.map(d => {
        const column = this.customFields.find(e => e.key === d.field);
        d.display = column ? column.display : false;
        return d;
      });
    } else {
      this.customFields = customFields;
      await this.commonService
        .settingUserConfig({
          user_id: this.user._id,
          report_user_group_table_columns: JSON.stringify(this.customFields),
        })
        .toPromise();
    }
    await this.loadData();
  }

  async loadTicketFields() {
    const res = await this.sharedCommonSettings.getAllTicketFields();
    res.forEach(e => {
      if (e.type === 'select') {
        this.ticketFields.push({
          key: e.key,
          title: e.title,
          display: false,
          data: e.data,
        });
      }
    });
  }

  loadAllUsers(res) {
    if (!res.error && res.status == 200) {
      this.allUsers = res.data.list || [];
    }
  }

  loadData(): void {
    this.isLoading = true;
    let payload: any = {
      from_date: moment(this.modelFilter.from_date).format('YYYY-MM-DD'),
      to_date: moment(this.modelFilter.to_date).add(1, 'days').format('YYYY-MM-DD'),
      top_limit: Number(this.modelFilter.amount) || 5,
    };
    payload['fields'] = this.customFields.filter(field => field.display).map(field => field.key);

    this.reportService.summaryGroupv3(payload).subscribe(
      res => {
        this.isLoading = false;
        if (res && !res.error) {
          this.dataReceptionTop = res.data.top || [];
          let total = 0;
          this.dataReceptionTop.forEach(value => (total += value.total));
          this.dataReceptionTop = this.dataReceptionTop
            .filter(value => value.total > 0)
            .map(value => {
              value.count = value.total;
              value.percent = Number(((value.total / this.dataReceptionTop[0].total) * 100).toFixed(2));
              return value;
            });

          this.dataSummaryWorkingTime = res.data.list || [];
          this.dataSummaryWorkingTime = this.dataSummaryWorkingTime.map((e, i) => {
            Object.keys(e).forEach(key => {
              if (key.includes('_percent')) {
                const value = e[key];
                if (typeof value === 'string' && value.includes('%')) {
                  const numericValue = parseFloat(value.split('%')[0]);
                  if (isNaN(numericValue)) {
                    e[key] = '0%';
                  } else {
                    e[key] = numericValue.toFixed(2) + '%';
                  }
                }
              }
            });
            e['STT'] = i + 1;
            return e;
          });
          this.totalItem = this.dataSummaryWorkingTime.length;
          this.totalPage = Math.ceil(this.totalItem / this.page_size);
          this.paginationData();
        } else {
          console.error('Invalid response format');
          this.toastr.error('Đã xảy ra lỗi khi tải dữ liệu');
        }
      },
      error => {
        console.error('Error fetching data:', error);
        this.toastr.error('Đã xảy ra lỗi khi tải dữ liệu');
      }
    );
  }

  paginationData() {
    this.dataSummaryWorkingTimeView = this.dataSummaryWorkingTime.slice(
      (this.currentPage - 1) * this.page_size,
      this.currentPage * this.page_size
    );
  }

  setPage(page) {
    this.currentPage = page;
    this.paginationData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.initData().then((data) => {})
  }

  ngAfterViewInit(): void {}

  onDateChange(key, value): void {
    this.loadData();
  }

  choiceFilter(data) {
    this.autoSubmitOnInit = false;
    this.selectFilter = 'Bộ lọc mới';
    this.filterHtml = { ...data };
    this.filterModal = {
      sub_and_or: 'and',
      main_and_or: 'and',
    };
  }

  async handleClickFieldContact(key, item) {
    this.dataReceptionDetail = {
      group: item,
      payload: this.modelFilter,
    };
  }

  goBack() {
    this.autoSubmitOnInit = false;
    this.dataReceptionDetail = null;
    this.displayFilter = false;
  }

  viewDetailsTicket(item, key) {
    this.loadDetailTicketKey = key;
  }

  async changedOptionView(data) {
    this.customFields = data;
    await this.commonService
      .settingUserConfig({
        user_id: this.user._id,
        report_user_group_table_columns: JSON.stringify(this.customFields),
      })
      .toPromise();
    this.displayColumns = this.displayColumns.map(d => {
      const column = data.find(e => e.key === d.field);
      d.display = column ? column.display : false;
      return d;
    });
    await this.loadData();
  }

  changedOptionViewChild(data) {
    this.displayColumnsTicket = data;
  }

  export(type): void {
    console.log(type, 'item');
    let exportDatas: any = {
      data: [],
    };
    let data: any = {};
    let title = '';
    switch (type) {
      case this.exportType.ReceptionTop:
        this.dataReceptionTop.map((value, index) => {
          let data_json: any = {};
          data_json['STT'] = index + 1;
          data_json['Phòng ban'] = value.name;
          data_json['Số lượng'] = value.count;
          exportDatas.data.push(data_json);
        });
        data['title'] = 'Thống kê Top phòng ban tiếp nhận cao';
        data['column'] = ['STT', 'Phòng ban', 'Số lượng'];
        data['isDate'] = true;
        data['dates'] =
          `Từ ngày: ${moment(this.modelFilter.from_date).format('YYYY-MM-DD')} - Đến ngày: ${moment(this.modelFilter.to_date).format('YYYY-MM-DD')}`;
        data['colWidths'] = [10, 40, 24];
        title = 'Thống kê Top phòng ban tiếp nhận cao';
        break;
      default:
        break;
    }

    this.exportCustomService.exportExcelCustom(
      exportDatas.data,
      title + ' ' + moment(new Date()).format('YYYY-MM-DD HH-mm'),
      data // Adding a default sheet name as the third argument
    );
  }

  goBackByType() {
    this.dataReceptionDetail = null;
  }
  public goPage2(toPage: any) {
    toPage = Number(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/group/group.component.ts